module.exports = __webpack_public_path__ + "img/left_opening.fd613854.svg";